import React from 'react';

import classNames from 'classnames';
import Col from 'react-bootstrap/lib/Col';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import { FormattedMessage } from 'react-intl';

import messages from './FormField.messages';
import Input from './Input';
import Select from './Select';

class Multiple extends React.PureComponent {
    static defaultProps = {
        wrapperClass: '',
        wrapperGrid: {
            xs: 12,
            sm: 6
        },
        optional: false,
        subText: null
    };

    constructor() {
        super();
        this.renderFieldsErrors = this.renderFieldsErrors.bind(this);
        this.renderInputFields = this.renderInputFields.bind(this);
        this.invalidClassName = this.invalidClassName.bind(this);
    }

    invalidClassName(fields) {
        const { customErrorMessage, wrapperClass } = this.props;

        const hasAnyErrorFields = fields.some((fields) => {
            return fields.field.touched && fields.field.error;
        });

        const errorFieldExists =
            hasAnyErrorFields || customErrorMessage || null;

        return classNames(wrapperClass, { invalid: errorFieldExists });
    }

    renderFieldsErrors() {
        const { fields, customErrorMessage } = this.props;
        return fields.map(({ field }) => {
            const error = field.error || customErrorMessage;
            return error ? (
                <div
                    key={field.name}
                    data-testid={`${field.name}-error`}
                    className="error multi-error">
                    <FormattedMessage id={error} defaultMessage={error} />
                </div>
            ) : null;
        });
    }

    renderInputFields() {
        const { fields } = this.props;
        return fields.map(
            ({
                grid,
                field,
                type,
                className,
                inputAttributes,
                selectAttributes
            }) => {
                grid = grid
                    ? grid
                    : { xs: 12 / fields.length, sm: 12 / fields.length };
                return (
                    <Col
                        key={field.name}
                        {...grid}
                        className={classNames('no-pad', className)}>
                        {(() => {
                            switch (type) {
                                case 'input':
                                    return (
                                        <Input
                                            field={field}
                                            {...inputAttributes}
                                        />
                                    );
                                case 'select':
                                    return <Select {...selectAttributes} />;
                                default:
                                    return null;
                            }
                        })()}
                    </Col>
                );
            }
        );
    }

    render() {
        const { fields, label, wrapperGrid, optional, subText } = this.props;

        return (
            <Col
                data-testid="test-form-field-multiple"
                {...wrapperGrid}
                className={this.invalidClassName(fields)}>
                <ControlLabel>
                    {label}
                    {optional ? (
                        <FormattedMessage {...messages.optional}>
                            {(message) => (
                                <span className="helper"> ({message})</span>
                            )}
                        </FormattedMessage>
                    ) : null}
                </ControlLabel>
                <div className="multi-error-container">
                    {this.renderFieldsErrors()}
                </div>
                {this.renderInputFields()}
                {subText ? (
                    <div className="toggle-role"> {subText} </div>
                ) : null}
            </Col>
        );
    }
}
export default Multiple;
